export const DICTIONARY_API_SETTINGS_CONTROLLER_END_POINTS = {
  CONTROLLER_PATH: "settings",
};
